import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router';

type Variante = 'principal' | 'secundario' | 'discreto';
type Tamanho = 'md' | 'sm';

// Retorno no toque (active), nao so no hover; rotulo de controle nao e texto selecionavel.
const BASE =
  'inline-flex items-center justify-center gap-2 rounded-(--radius-controle) font-medium whitespace-nowrap select-none transition-[color,background-color,border-color,transform] duration-100 ease-out active:scale-[0.97] disabled:pointer-events-none disabled:opacity-45';

const VARIANTES: Record<Variante, string> = {
  principal: 'bg-marca text-sobre-marca hover:bg-marca/90',
  secundario: 'border border-borda-forte bg-superficie text-texto hover:border-destaque hover:text-destaque-texto',
  discreto: 'text-destaque-texto hover:bg-destaque-fundo',
};

const TAMANHOS: Record<Tamanho, string> = {
  md: 'px-4 text-sm',
  sm: 'px-3 text-[13px]',
};

export const classesBotao = (variante: Variante = 'secundario', tamanho: Tamanho = 'md') =>
  `${BASE} ${VARIANTES[variante]} ${TAMANHOS[tamanho]}`;

export function Botao({
  variante = 'secundario',
  tamanho = 'md',
  carregando = false,
  className = '',
  children,
  ...p
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: Variante;
  tamanho?: Tamanho;
  carregando?: boolean;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      {...p}
      disabled={p.disabled || carregando}
      aria-busy={carregando || undefined}
      className={`${classesBotao(variante, tamanho)} ${className}`}
    >
      {carregando && (
        <span aria-hidden className="size-3.5 shrink-0 animate-spin border-2 border-current border-r-transparent" />
      )}
      {children}
    </button>
  );
}

/** Link com cara de botao: navegacao nunca e <button>. */
export function BotaoLink({
  variante = 'secundario',
  tamanho = 'md',
  className = '',
  ...p
}: LinkProps & { variante?: Variante; tamanho?: Tamanho }) {
  return <Link {...p} className={`${classesBotao(variante, tamanho)} min-h-9 pointer-coarse:min-h-11 ${className}`} />;
}
